import { v4 as uuidv4 } from "uuid";

export const getSessionId = (refreshSession = false) => {
  let sessionId = localStorage.getItem("session_id");

  if (!sessionId || refreshSession) {
    sessionId = uuidv4();
    localStorage.setItem("session_id", sessionId);
  }

  return sessionId;
};
